import React, { useRef, useState } from "react";
import "../../Registration/MainRegister/mainRegister.css";
import { Link, useNavigate } from "react-router-dom";
import "../LoginWithMPIN/loginWithMPIN.css";
import { IoEyeOutline } from "react-icons/io5";
import { IoEyeOffOutline } from "react-icons/io5";
import axios from "../../../axios";
import NotRegisterPopUp from "../NotRegisterNotify/NotRegisterPopUp";
import ForgotMPINVerify from "../ForgotPin/ForgotMPINVerify";
import { useEffect } from "react";
import {
  setUserInformation,
  setSchoolId,
} from "../../../redux/initialDataSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function LoginWithMPN({ setLeftSidebarSize }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputsRef = useRef([]);
  const [showMpin, setShowMpin] = useState(false);
  const [userLogin, setUserLogin] = useState({
    userId: "",
    Mpin: "",
  });
  const [mpin, setMpin] = useState(Array(6).fill(""));
  const uname = JSON.parse(localStorage.getItem("UserName"));
  const School_ID = JSON.parse(localStorage.getItem("School_id"));
  const schoolCode = localStorage.getItem("schoolCodeForTeacher");

  // const timeTableSessionIdArray = [
  //     { id1: 123 },
  //     { id2: 456 },
  //     { id3: 789 },
  //     { id4: 321 },
  //     { id5: 654 },
  // ]

  const [validMpin, setValidMpin] = useState();
  function myFunction() {
    var x = document.getElementById("myId");
    var y = document.getElementById("close_eye");
    var Z = document.getElementById("open_eye");

    if (x.type === "password") {
      x.type = "text";
      y.style.display = "none";
      Z.style.direction = "block";
    } else {
      x.type = "password";
      y.style.display = "block";
      Z.style.directio = "none";
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let loginMpinUser = {
      user_id: School_ID,
      mpin: userLogin.Mpin,
      school_code: schoolCode,
    };

    try {
      const res = await axios.post(
        `/api/v1/teacherAuth/loginWithMpin`,
        loginMpinUser,
      );
      if (res && res.data.data) {
        // Save to localStorage
        localStorage.setItem(
          "AuthToken",
          JSON.stringify(res.data?.data?.accessToken),
        );
        localStorage.setItem(
          "features",
          JSON.stringify(res.data?.data?.features),
        );
        localStorage.setItem("Header", "Digital Class Management");
        localStorage.setItem("UserInformation", JSON.stringify(res.data.data));
        dispatch(setUserInformation(res?.data?.data));
        dispatch(setSchoolId(res.data.data.school?.id));
        const schoolId = res?.data?.data?.school?.id;
        localStorage.setItem("schoolId", JSON.stringify(schoolId));
        // const timeTableSessionId = res.data.data?.timetable_session?.id;
        // if (timeTableSessionId !== null && timeTableSessionId !== undefined) {
        //     localStorage.setItem('timeTableSessionId', JSON.stringify(timeTableSessionId));
        // } else {
        //     // toast.error("Encountered an error, hence unable to process the request!")
        //     localStorage.setItem('timeTableSessionId', JSON.stringify(""));
        // }
        setLeftSidebarSize(70);
        navigate("/loginSuccess", { state: { loginRes: res.data.data } });
      }
    } catch (error) {
      console.log(error);
      setValidMpin(error.response.data);
    }
  };

  useEffect(() => {
    userLogin.Mpin === "" && setValidMpin("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLogin.Mpin]);

  const [popup, setPopup] = useState();
  const [verifyUser, setVerifyUser] = useState();

  const handleChange = (e, i) => {
    const val = e.target.value.replace(/[^0-9]/g, ""); // allow only numbers
    if (!val) return;

    const newMpin = [...mpin];
    newMpin[i] = val.slice(-1); // only last digit
    setMpin(newMpin);

    // move focus to next box if not last
    if (i < mpin.length - 1 && val) {
      inputsRef.current[i + 1].focus();
    }

    // update in your userLogin object (like your old code)
    setUserLogin({
      ...userLogin,
      Mpin: newMpin.join(""), // join digits into one string
    });
  };

  const handleKeyDown = (e, i) => {
    if (e.key === "Backspace") {
      const newMpin = [...mpin];

      if (mpin[i]) {
        // Case 1: current box has a digit → clear it
        newMpin[i] = "";
        setMpin(newMpin);
      } else if (i > 0) {
        // Case 2: current box is empty → move to previous box and clear it
        inputsRef.current[i - 1].focus();
        newMpin[i - 1] = "";
        setMpin(newMpin);
      }
      e.preventDefault(); // stop default backspace behavior (cursor movement)
    }
  };

  const toggleShowMpin = () => {
    setShowMpin(!showMpin);
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    let loginMpinUser = {
      school_assigned_id: School_ID,
      school_code: schoolCode,
    };

    try {
      const res = await axios.post(
        `/api/v1/teacherAuth/validateShoolAssignedId`,
        loginMpinUser,
      );

      res.data.status === "Not-Registered" && setPopup(true);
      res.data.status === "Registered" && setVerifyUser(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="TotalContainer d-md-flex">
      <div className="banner_box  col-lg-3 col-md-5col-12 p-0 m-0">
        <img
          className="banner_img "
          src="/Register-img/baner_img.jpg"
          alt="banner img"
        ></img>
      </div>
      <div className="form_box_loin  col-lg-9 col-md-7  col-12 p-0 ">
        <form>
          <div>
            <div className="total_logo_regist">
              <img
                className="logo_registration"
                src="/AppLogo.png"
                alt="Register_logo"
              ></img>
            </div>
            <div className="title_regis">
              {/* Hello&nbsp;{uname} */}
              Welcome {uname}
            </div>
            <div className="login_mpin">Login with Pin</div>

            <div className="input_box2">
              <div className="school_id_mpin" type="text" placeholder="User ID">
                {School_ID}
              </div>
            </div>

            <div className="input_box3">
              {/* <input
                id="myId"
                type="password"
                required
                placeholder="Enter Pin"
                maxLength={4}
                onChange={(e) =>
                  setUserLogin({
                    ...userLogin,
                    Mpin: e.target.value,
                  })
                }
                autocomplete="off"
              ></input> */}
              <div style={{ display: "flex", gap: "8px" }}>
                {mpin.map((val, i) => (
                  <input
                    key={i}
                    ref={(el) => (inputsRef.current[i] = el)}
                    type={showMpin ? "text" : "password"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={1}
                    value={val}
                    placeholder="_"
                    onChange={(e) => handleChange(e, i)}
                    onKeyDown={(e) => handleKeyDown(e, i)}
                    style={{
                      width: 50,
                      height: 50,
                      textAlign: "center",
                      fontSize: 24,
                      border: "1px solid #ccc",
                      borderRadius: 8,
                    }}
                  />
                ))}
              </div>
              {/* <span onClick={myFunction} className="Eye_login">
                <IoEyeOffOutline id="close_eye" />
                <IoEyeOutline id="open_eye" />
              </span> */}
              <span onClick={toggleShowMpin}>
                {showMpin ? <IoEyeOutline /> : <IoEyeOffOutline />}
              </span>
            </div>
            {validMpin?.status === false && (
              <div className="invailidOtp">Invalid Pin entered</div>
            )}

            <div>
              <button
                class={"btn btn"}
                id={!userLogin.Mpin ? "btn_disabled" : "main_login_btn"}
                type="submit"
                onClick={handleSubmit}
                disabled={!userLogin.Mpin}
              >
                Login
              </button>
            </div>

            <div className="forgot_MPIN" onClick={handleForgot}>
              Forgot Pin?
            </div>
            <div className="or_line">Or</div>
            <div>
              <Link to="/LoginWithPassWord">
                <button class="btn btn" id="Login_with_pass_Btn" type="button">
                  Login with Password
                </button>
              </Link>
            </div>
            {/* Here I commented code for remove Login with OTP functionality */}
            {/* <div >
                            <Link to='/LoginWithOTP'>  <button class="btn btn" id='Login_with_pass_Btn' type="button">Login with OTP</button></Link>
                        </div> */}

            <div className="total_already_login">
              <span className="not_john">Not {uname}?</span>&nbsp;
              <Link className="Link_register" to="/">
                <span className="login_diff_ccount">
                  Login with different account
                </span>
              </Link>
            </div>
          </div>
        </form>
      </div>
      {popup && <NotRegisterPopUp setPopup={setPopup} />}
      {verifyUser && <ForgotMPINVerify setVerifyUser={setVerifyUser} />}
    </div>
  );
}
